import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import useTranslation from '../../../hooks/translation-hook';
import Label from '../Label';

export default function QualityWarningContent({ compact = false, centered = false }: { compact?: boolean; centered?: boolean }) {
  const t = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const textAlign = centered ? 'center' as const : 'left' as const;
  if (compact) return <View testID="quality-warning-reminder" style={{ flexDirection: 'row', alignItems: 'flex-start', minWidth: 0, gap: 8 }}>
    <View accessibilityElementsHidden importantForAccessibility="no-hide-descendants" style={{ marginTop: 1 }}>
      <FontAwesomeIcon icon={faCircleExclamation} size={18} color="#744200" />
    </View>
    <Label numberOfLines={0} style={{ color: '#035164', fontSize: 14, lineHeight: 20, fontWeight: '600', flex: 1 }}>
      {t('quality-warning-reminder')}
    </Label>
  </View>;

  return <View testID="quality-warning-content" style={{ minWidth: 0, gap: 12 }}>
    {!centered && <View accessible accessibilityRole="header" style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 8 }}>
      <FontAwesomeIcon icon={faCircleExclamation} size={20} color="#744200" style={{ marginTop: 1 }} />
      <Label accessibilityRole="header" numberOfLines={0} style={{ color: '#5B3600', fontWeight: '700', flex: 1 }}>{t('quality-warning-label')}</Label>
    </View>}
    <Label numberOfLines={0} style={{ color: '#035164', textAlign, fontSize: centered ? 18 : 14, lineHeight: centered ? 24 : 21 }}>
      {t('quality-warning-body')}
      <Text style={{ fontWeight: '700' }}> {t('quality-warning-reminder')}</Text>
    </Label>
    <Pressable accessibilityRole="button" accessibilityState={{ expanded }} onPress={() => setExpanded(value => !value)}
      style={{ minHeight: 44, justifyContent: 'center', alignItems: centered ? 'center' : 'flex-start' }}>
      <Label numberOfLines={0} style={{ color: '#035164', textDecorationLine: 'underline', textAlign }}>{t('quality-warning-details')}</Label>
    </Pressable>
    {expanded && <View style={{ gap: 12 }}>
      <Label numberOfLines={0} style={{ color: '#035164', textAlign, lineHeight: 21 }}>{t('quality-warning-clearance')}</Label>
      <Label numberOfLines={0} style={{ color: '#035164', textAlign, lineHeight: 21 }}>{t('quality-warning-details-body')}</Label>
    </View>}
  </View>;
}
